const LogEventKeys = {
  // BASE PREFIX FOR LOG EVENT KEYS
  ROOT_KEY: 'automation-ui-log-events',
  // ACTION_EXECUTION
  ACTION: 'action',
  ACTION_EXECUTION_INDEX: 'actionExecutionIndex',
  ACTION_SPECIFIC_ERROR_TYPE: 'actionSpecificErrorType',
  ERROR_SUB_TYPE: 'errorSubType',
  ERROR_TYPE: 'errorType',
  EXECUTION_STATE: 'executionState',
  FAIL_SUB_TYPE: 'failSubType',
  FAIL_TYPE: 'failType',
  MESSAGE: 'message',
  NEXT_ACTION_ID: 'nextActionId',
  SKIP_REASON: 'skipReason',
  // ENROLLMENT
  ENROLL_TYPE: 'enrollType',
  ENROLLMENT_STATE: 'enrollmentState',
  UNENROLL_TYPE: 'unenrollType',
  // PRE_ENROLLMENT
  FILTER_EVENT_TYPE: 'filterEventType',
  PRE_ENROLLMENT_ID: 'preEnrollmentId',
  TRIGGER_ENROLL_TYPE: 'triggerEnrollType',
  // Shared
  CONTEXT_MAP: 'contextMap',
  ENROLLMENT_ID: 'enrollmentId',
  FLOW_ID: 'flowId',
  FLOW_OBJECT_TYPE: 'flowObjectType',
  ID: 'id',
  IDEMPOTENCY_ID: 'idempotencyId',
  NOTIFICATION_TYPE: 'notificationType',
  OBJECT_ID: 'objectId',
  OBJECT_TYPE_ID: 'objectTypeId',
  PORTAL_ID: 'portalId',
  TIMESTAMP: 'timestamp',
  TYPE: 'type',
  LOG_EVENT_MESSAGE: 'logEventMessage'
};
export default LogEventKeys;